import React from "react";

import { useAuth0 } from "@auth0/auth0-react";

const Hero = () => {
    const { user } = useAuth0();

    if (!user) {
        return (
            <div className="text-center hero my-5">
                <h1 className="mb-4">Hello Anonymous User 👋</h1>
            </div>
        );
    }

    const name = user.nickname ?? user.name ?? user.email ?? user.sub;
    return (
        <div className="text-center hero my-8">
            <h1 className="mb-4">Hello {name} 👋</h1>
        </div>
    );
};

export default Hero;
